const baseRoute = "/procurement/direct-sales"

export const auctionMenu = [
    { title: "Active Species List", link: baseRoute + "/species" },
    { title: "Direct Selection List", link: baseRoute + "/selection-list" },
    { title: "Direct Offers", link: baseRoute + "/offers" },
    { title: "Staging Basket", link: baseRoute + "/staging-basket" },
    // { title: "Purchase Orders", link: baseRoute + "/purchase-orders" },
]